import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["colorantSelect", "quantityInput", "quantityLabel"]

  connect() {
    this.updateQuantityField()
  }

  updateQuantityField() {
    const colorantId = this.colorantSelectTarget.value
    const hasColorant = colorantId && colorantId !== ""

    // Enable/disable quantity input based on colorant selection
    this.quantityInputTarget.disabled = !hasColorant

    if (hasColorant) {
      // Fetch colorant unit and update label
      this.fetchColorantUnit(colorantId)
    } else {
      // Reset to default label
      this.quantityLabelTarget.textContent = "Quantité"
      // Clear quantity when colorant is deselected
      this.quantityInputTarget.value = ""
    }
  }

  fetchColorantUnit(colorantId) {
    fetch(`/crafting/colorants/${colorantId}.json`)
      .then(response => response.json())
      .then(data => {
        const unit = data.unit || "ml"
        this.quantityLabelTarget.textContent = `Quantité (${unit})`
      })
      .catch(error => {
        console.error('Error fetching colorant unit:', error)
        this.quantityLabelTarget.textContent = "Quantité"
      })
  }
}

